module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_1_Inactive@1x-f90ff0fcd1559d621a045687d4555af0.png";